export const LoginInitialValues = {
    email: "",
    password: "",
    isSubmitting: false,
    errorMessage: null
}